import React from "react";
import { RebalanceSummaryContainer } from "../../../../../containers";
const RebalanceSummary = (props) => {
  return <RebalanceSummaryContainer {...props} />;
};

export default RebalanceSummary;
